<template>
    <div id="systemSettingsIndex">
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="content-warpper content-warpper-main">
        <div>
          <span class="header_line"></span>活动审批方式
        </div>
        <div class="radio_container">
          <div>
            <el-radio v-model="campaigntype" label="0" :disabled="!btnShow">由店铺的直属上级审批</el-radio>
            <span class="info">店铺或经销商申报活动后，默认提交给店铺直属上级审批。</span>
          </div>
          <div>
            <el-radio v-model="campaigntype" label="1"  :disabled="!btnShow">由品类负责人审批</el-radio>
            <span class="info">店铺或经销商申报活动后，默认提交给活动产品的品类负责人审批。</span>
          </div>
        </div>
        <div class="btn_edit">
          <el-button size="small" @click="btnShow=true" v-show="!btnShow">编辑</el-button>
        </div>
        <div v-show="btnShow">
          <el-button type="confire_btn" @click="updatecampaigntype" size="small">确认</el-button>
          <el-button @click="cancel" size="small" type="cancel_blue">取消</el-button>
        </div>
      </section>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                campaigntype:'',
                btnShow:false,
            }
        },
        created(){
          this.selectbmcCampaigntype()
        },
        methods:{
            cancel(){
                this.$set(this,'campaigntype','')
            },
            updatecampaigntype(){
                if(this.campaigntype==''){
                    this.$message.warning('请选择活动审批方式')
                    return false
                }
                fetch({url: "hcm/cus/updatecampaigntype", method: "post", data:{campaigntype:this.campaigntype},})
                    .then((res)=>{
                        if(res.status=='10000'){
                            this.$message.success('成功')
                            this.btnShow=false
                        }
                        else this.$message.error(res.message);
                    })
            },
            selectbmcCampaigntype(){
                fetch({url: "/hcm/cus/selectbmcSetting", method: "get"})
                    .then((res)=>{
                        if(res.status == '10000')this.campaigntype=res.data.campaigntype
                    })
            }
        }
    }
</script>
<style lang="scss">
    @import "src/style/tableCommon";
    #systemSettingsIndex{
        .el-radio__input.is-checked .el-radio__inner{
            background: #bda470;
            border-color: #bda470;
        }
        .el-radio__inner{
            width: 21px;
            height: 21px;
        }
        .el-radio__inner::after{
            width: 7px;
            height: 7px;
        }
        .el-radio__input.is-checked+.el-radio__label{
            color:#606266;
        }

        .el-radio{
            width: 230px;
            font-size: 16px;
        }
        .el-radio__label{
            font-size: 16px;
        }
        .radio_container{
            height: 120px;
        }
        .radio_container>div{
            margin-top:40px;
        }
        .info{
            font-size: 14px;
            color:#666;
        }
    }
</style>
